import axios from "axios";
import * as types from '../constants/ActionTypes';
import { toast } from 'react-toastify';

// Url's
// const cartGetURL = `${process.env.REACT_APP_API_URL}api/csa-app/get-line-items`;
// const addToCartURL = `${process.env.REACT_APP_API_URL}api/csa-app/add-item-to-cart`;
// const updateToCartURL = `${process.env.REACT_APP_API_URL}api/csa-app/update-item-quantity`;
// const removeFromCartURL = `${process.env.REACT_APP_API_URL}api/csa-app/delete-item`;

const cartGetURL = `${process.env.REACT_APP_API_URL}mobileshop/csacart/get-line-items`;
const addToCartURL = `${process.env.REACT_APP_API_URL}mobileshop/csacart/add-item-to-cart`;
const updateToCartURL = `${process.env.REACT_APP_API_URL}mobileshop/csacart/update-item-quantity`;
const removeFromCartURL = `${process.env.REACT_APP_API_URL}mobileshop/csacart/delete-item`;

// Actions
const cartInfoSuccess = data => ({
  type: types.CARTINFO_SUCCESS,
  data
});

const cartInfoRequested = () => ({
  type: types.CARTINFO_REQUEST
});

const cartInfoFailure = error => ({
  type: types.CARTINFO_FAILURE,
  error
});

const cartInfoUpdate = () => ({
  type: types.CARTINFO_UPDATE
});

const cartInfoDelete = () => ({
  type: types.CARTINFO_DELETE
});


const cartInfoClear = () => ({
  type: types.CARTINFO_CLEAR
});


// API
export const getCartInfo = (options) => {
  
  return dispatch => {
    dispatch(cartInfoRequested());
    axios.get(cartGetURL, {
      params: {
        connection_id: options.connection_id,
        web_session_trans_id: options.web_session_trans_id,
        tenant_name : options.tenant_name
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(cartInfoSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(cartInfoFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const clearCartInfo = (options) => {
  return dispatch => {
    dispatch(cartInfoClear());
  };
};

export const addToCart = (options) => {
  return dispatch => {
    dispatch(cartInfoRequested());
    axios.post(addToCartURL, options, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
        //'Content-Type': 'application/json; charset=UTF-8'
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          axios.get(cartGetURL, {
            params: {
              connection_id: options.connection_id,
              web_session_trans_id: options.web_session_trans_id,
            },
          })
            .then(res => {
              if (res.data.ack === "Success") {
                dispatch(cartInfoSuccess(res.data.results));
              } else if (res.data.ack === "Failure") {
                dispatch(cartInfoFailure(res.data.status));
              }
            })
          // dispatch(cartInfoSuccess(res.data.results));
          toast.success("Selected Item added to shopping Bag.");
        } else if (res.data.ack === "Failure") {
          // dispatch(cartInfoFailure(res.data.status));
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(cartInfoFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};


export const updateToCart = (options) => {
  return dispatch => {
    dispatch(cartInfoRequested());
    axios.put(updateToCartURL, options, {
      headers: {
        'Accept': 'application/json',
          'Content-Type': 'application/json'
        //'Content-Type': 'application/json; charset=UTF-8'
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          axios.get(cartGetURL, {
            params: {
              connection_id: options.connection_id,
              web_session_trans_id: options.web_session_trans_id,
            },
          })
            .then(res => {
              if (res.data.ack === "Success") {
                dispatch(cartInfoSuccess(res.data.results));
              } else if (res.data.ack === "Failure") {
                dispatch(cartInfoFailure(res.data.status));
              }
            })
          // dispatch(cartInfoSuccess(res.data.results));
          toast.success("Selected Item updated to shopping Bag.");
        } else if (res.data.ack === "Failure") {
          // dispatch(cartInfoFailure(res.data.status));
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(cartInfoFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

export const removeFromCart = (options) => {
  return dispatch => {
    dispatch(cartInfoRequested());
    axios.delete(removeFromCartURL, {
      headers: {
        'Accept': 'application/json',
          'Content-Type': 'application/json'
        //'Content-Type': 'application/json; charset=UTF-8'
      },
      data: options
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(cartInfoDelete());
          axios.get(cartGetURL, {
            params: {
              connection_id: options.connection_id,
              web_session_trans_id: options.web_session_trans_id,
            },
          })
            .then(res => {
              if (res.data.ack === "Success") {
                dispatch(cartInfoSuccess(res.data.results));
              } else if (res.data.ack === "Failure") {
                toast.error(`Failed - ${res.data.status.message}`);
                dispatch(cartInfoFailure(res.data.status));
              }
            })
          toast.success("Selected Product removed from shopping bag.");
        } else if (res.data.ack === "Failure") {
          // dispatch(cartInfoFailure(res.data.status));
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(cartInfoFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
